export const SOCIAL_CHOICE_LINK = '/app/social-security/choice';
export const SOCIAL_BENEFITS_LINK = '/app/social-security/expected-benefits';
export const PROFILE_LINK = '/app/profile';
export const CASHFLOW_LINK = '/app/cashflow';
export const PORTFOLIO_LINK = '/app/portfolio';
export const ACCOUNT_LINK = '/app/account';
export const INCOME_LINK = '/app/income';
export const HOUSING_LINK = '/app/expenses/housing'
export const OTHER_INCOME_LINK = '/app/income/other';

export const ADMIN_PAGE_LINK = '/admin';

export function hasLinkUnlocked(currentLink, flows) {
    let linkMap = {
        [CASHFLOW_LINK]: flows['cashflow'],
    }

    if (!linkMap[currentLink]) {
        return false;
    }

    return true;
}

